import React, { useState, useEffect, useContext, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Button,
  Alert,
  CardTitle,
  CustomInput,
  FormText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import Select from 'react-select';
import { ChromePicker, TwitterPicker } from 'react-color';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { getCookie } from '../../jwt/_helpers/cookie';
import TenantContext from '../../utils/tenantContext';
import { StateContext } from '../../utils/context';
import {
  applyBrandingCssVars,
  getButtonBorderRadius,
  isLightColor,
} from '../../utils/sidebarBrandingColors';
import LoaderInner from '../../components/LoaderInner';
import BrandingPreview from './brandingPreview';
import LoginPreview from './loginPreview';
import formValidation from '../../validations/es6/core/Core';
import { Link } from 'react-router-dom';
import { opt } from './brandingConfigOpt';
import { updateProfile } from '../../redux/profile/action';
import { updateBranding } from '../../redux/branding/action';
import { isDemoMode, isBrowserSessionDemo, isDemoLocked } from '../../utils/demoConfig';
import { putDemoTrackBlob, WL_DEMO_BLOB_PREFIX } from '../../utils/demoTrackBlobStore';
import { resolveBrandingLogoObjectUrl } from '../../utils/brandingAssetUrl';
import { setRuntimeReleaseListLayoutConfig } from '../../components/releaseTableHelpers';
import {
  EXISTING_USERS_HANDLING,
  getSubscriptionsEnabled,
  isSubscriptionsSlaEligible,
} from '../../utils/subscriptionUtils';
import './brandingConfig.css';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const DEFAULT_THEME_COLOR = '#000a60';
const DEFAULT_SIDEBAR_COLOR = '#ffffff';
const DEFAULT_FONT_FAMILY = '"Nunito Sans", sans-serif';
const DEFAULT_INFO_COLOR = '#2bcfe0';
const DEFAULT_SUCCESS_COLOR = '#2b9e62';
const DEFAULT_WARNING_COLOR = '#fb6340';
const DEFAULT_DANGER_COLOR = '#ea2817';
const DEFAULT_SCOOTER_COLOR = '#2bcfe0';
const DEFAULT_BUTTON_STYLE = 'standard';
const DEFAULT_LIST_LAYOUT = 'table_card';

const BRANDING_SECTION_TITLE_STYLE = {
  fontSize: '0.9375rem',
  fontWeight: 600,
  color: '#333',
  marginBottom: '0.75rem',
  lineHeight: 1.3,
};

const BRANDING_SECTION_DIVIDER_STYLE = {
  margin: '1.25rem 0',
  borderColor: '#e9ecef',
};

const BRANDING_FIELD_SUBTITLE_STYLE = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  color: '#6c757d',
  marginBottom: '0.75rem',
  lineHeight: 1.3,
};

const BRANDING_POLICY_LABEL_STYLE = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  color: '#6c757d',
  marginBottom: '0.5rem',
};

const fontOptions = [
  { value: 'Agdasima, sans-serif', label: 'Agdasima' },
  { value: 'Alatsi, sans-serif', label: 'Alatsi' },
  { value: 'Alegreya Sans, sans-serif', label: 'Alegreya Sans' },
  { value: 'Almarai, sans-serif', label: 'Almarai' },
  { value: 'Anonymous Pro, monospace', label: 'Anonymous Pro' },
  { value: 'Arsenal, sans-serif', label: 'Arsenal' },
  { value: 'Arsenal SC, sans-serif', label: 'Arsenal SC' },
  { value: 'Arya, sans-serif', label: 'Arya' },
  { value: 'Asap Condensed, sans-serif', label: 'Asap Condensed' },
  { value: 'Asul, serif', label: 'Asul' },
  { value: 'Average Sans, sans-serif', label: 'Average Sans' },
  { value: 'Bai Jamjuree, sans-serif', label: 'Bai Jamjuree' },
  { value: 'Blinker, sans-serif', label: 'Blinker' },
  { value: 'Boldonse, sans-serif', label: 'Boldonse' },
  { value: 'Cabin Condensed, sans-serif', label: 'Cabin Condensed' },
  { value: 'Cal Sans, sans-serif', label: 'Cal Sans' },
  { value: 'Cambay, sans-serif', label: 'Cambay' },
  { value: 'Cantarell, sans-serif', label: 'Cantarell' },
  { value: 'Carrois Gothic, sans-serif', label: 'Carrois Gothic' },
  { value: 'Chocolate Classical Sans, sans-serif', label: 'Chocolate Classical Sans' },
  { value: 'Dhurjati, sans-serif', label: 'Dhurjati' },
  { value: 'Didact Gothic, sans-serif', label: 'Didact Gothic' },
  { value: 'DM Sans, sans-serif', label: 'DM Sans' },
  { value: 'Duru Sans, sans-serif', label: 'Duru Sans' },
  { value: 'Encode Sans Condensed, sans-serif', label: 'Encode Sans Condensed' },
  { value: 'Encode Sans Expanded, sans-serif', label: 'Encode Sans Expanded' },
  { value: 'Encode Sans Semi Condensed, sans-serif', label: 'Encode Sans Semi Condensed' },
  { value: 'Encode Sans Semi Expanded, sans-serif', label: 'Encode Sans Semi Expanded' },
  { value: 'Fira Sans, sans-serif', label: 'Fira Sans' },
  { value: 'Fragment Mono, monospace', label: 'Fragment Mono' },
  { value: 'Francois One, sans-serif', label: 'Francois One' },
  { value: 'Gafata, sans-serif', label: 'Gafata' },
  { value: 'GFS Neohellenic, sans-serif', label: 'GFS Neohellenic' },
  { value: 'Gidole, sans-serif', label: 'Gidole' },
  { value: 'Gidugu, sans-serif', label: 'Gidugu' },
  { value: 'Gowun Dodum, sans-serif', label: 'Gowun Dodum' },
  { value: 'Gruppo, sans-serif', label: 'Gruppo' },
  { value: 'Gudea, sans-serif', label: 'Gudea' },
  { value: 'Hedvig Letters Sans, sans-serif', label: 'Hedvig Letters Sans' },
  { value: 'Hind, sans-serif', label: 'Hind' },
  { value: 'Hind Guntur, sans-serif', label: 'Hind Guntur' },
  { value: 'Hind Madurai, sans-serif', label: 'Hind Madurai' },
  { value: 'Hind Mysuru, sans-serif', label: 'Hind Mysuru' },
  { value: 'Hind Siliguri, sans-serif', label: 'Hind Siliguri' },
  { value: 'Hind Vadodara, sans-serif', label: 'Hind Vadodara' },
  { value: 'IBM Plex Sans Condensed, sans-serif', label: 'IBM Plex Sans Condensed' },
  { value: 'IBM Plex Sans Devanagari, sans-serif', label: 'IBM Plex Sans Devanagari' },
  { value: 'Inria Sans, sans-serif', label: 'Inria Sans' },
  { value: 'Inter, sans-serif', label: 'Inter' },
  { value: 'Istok Web, sans-serif', label: 'Istok Web' },
  { value: 'Jost, sans-serif', label: 'Jost' },
  { value: 'Kanit, sans-serif', label: 'Kanit' },
  { value: 'Lato, sans-serif', label: 'Lato' },
  { value: 'Liter, sans-serif', label: 'Liter' },
  { value: 'Livvic, sans-serif', label: 'Livvic' },
  { value: 'Lunasima, sans-serif', label: 'Lunasima' },
  { value: 'Magra, sans-serif', label: 'Magra' },
  { value: 'Mallanna, sans-serif', label: 'Mallanna' },
  { value: 'Mandali, sans-serif', label: 'Mandali' },
  { value: 'Manjari, sans-serif', label: 'Manjari' },
  { value: 'Manrope, sans-serif', label: 'Manrope' },
  { value: 'Martel Sans, sans-serif', label: 'Martel Sans' },
  { value: 'Mingzat, sans-serif', label: 'Mingzat' },
  { value: 'Montserrat, sans-serif', label: 'Montserrat' },
  { value: 'Mukta, sans-serif', label: 'Mukta' },
  { value: 'Mulish, sans-serif', label: 'Mulish' },
  { value: 'Nanum Gothic, sans-serif', label: 'Nanum Gothic' },
  { value: 'News Cycle, sans-serif', label: 'News Cycle' },
  { value: 'Niramit, sans-serif', label: 'Niramit' },
  { value: 'Nobile, sans-serif', label: 'Nobile' },
  { value: 'Noto Sans, sans-serif', label: 'Noto Sans' },
  { value: 'Noto Sans Cypro Minoan, sans-serif', label: 'Noto Sans Cypro Minoan' },
  { value: 'Noto Sans Indic Siyaq Numbers, sans-serif', label: 'Noto Sans Indic Siyaq Numbers' },
  { value: 'Noto Sans Math, sans-serif', label: 'Noto Sans Math' },
  { value: 'Noto Sans Mayan Numerals, sans-serif', label: 'Noto Sans Mayan Numerals' },
  { value: 'Noto Sans SignWriting, sans-serif', label: 'Noto Sans SignWriting' },
  { value: 'Numans, sans-serif', label: 'Numans' },
  { value: 'Nunito Sans, sans-serif', label: 'Nunito Sans' },
  { value: 'Open Sans, sans-serif', label: 'Open Sans' },
  { value: 'Orienta, sans-serif', label: 'Orienta' },
  { value: 'Oswald, sans-serif', label: 'Oswald' },
  { value: 'Overpass, sans-serif', label: 'Overpass' },
  { value: 'Oxygen, sans-serif', label: 'Oxygen' },
  { value: 'Padauk, sans-serif', label: 'Padauk' },
  { value: 'Palanquin, sans-serif', label: 'Palanquin' },
  { value: 'Pavanam, sans-serif', label: 'Pavanam' },
  { value: 'Philosopher, sans-serif', label: 'Philosopher' },
  { value: 'Play, sans-serif', label: 'Play' },
  { value: 'Poiret One, sans-serif', label: 'Poiret One' },
  { value: 'Poppins, sans-serif', label: 'Poppins' },
  { value: 'Pragati Narrow, sans-serif', label: 'Pragati Narrow' },
  { value: 'Prompt, sans-serif', label: 'Prompt' },
  { value: 'Proza Libre, sans-serif', label: 'Proza Libre' },
  { value: 'PT Sans, sans-serif', label: 'PT Sans' },
  { value: 'PT Sans Caption, sans-serif', label: 'PT Sans Caption' },
  { value: 'PT Sans Narrow, sans-serif', label: 'PT Sans Narrow' },
  { value: 'Puritan, sans-serif', label: 'Puritan' },
  { value: 'Questrial, sans-serif', label: 'Questrial' },
  { value: 'Ramabhadra, sans-serif', label: 'Ramabhadra' },
  { value: 'Rambla, sans-serif', label: 'Rambla' },
  { value: 'Roboto, sans-serif', label: 'Roboto' },
  { value: 'Ropa Sans, sans-serif', label: 'Ropa Sans' },
  { value: 'Rubik, sans-serif', label: 'Rubik' },
  { value: 'Sansation, sans-serif', label: 'Sansation' },
  { value: 'Saira, sans-serif', label: 'Saira' },
  { value: 'Sarabun, sans-serif', label: 'Sarabun' },
  { value: 'Sarala, sans-serif', label: 'Sarala' },
  { value: 'Shippori Antique, sans-serif', label: 'Shippori Antique' },
  { value: 'Shippori Antique B1, sans-serif', label: 'Shippori Antique B1' },
  { value: 'Sintony, sans-serif', label: 'Sintony' },
  { value: 'Source Sans 3, sans-serif', label: 'Source Sans 3' },
  { value: 'Space Mono, monospace', label: 'Space Mono' },
  { value: 'Special Gothic Condensed One, sans-serif', label: 'Special Gothic Condensed One' },
  { value: 'Special Gothic Expanded One, sans-serif', label: 'Special Gothic Expanded One' },
  { value: 'Spinnaker, sans-serif', label: 'Spinnaker' },
  { value: 'Strait, sans-serif', label: 'Strait' },
  { value: 'Sunflower, sans-serif', label: 'Sunflower' },
  { value: 'Tajawal, sans-serif', label: 'Tajawal' },
  { value: 'Tauri, sans-serif', label: 'Tauri' },
  { value: 'Telex, sans-serif', label: 'Telex' },
  { value: 'Tenali Ramakrishna, sans-serif', label: 'Tenali Ramakrishna' },
  { value: 'Thasadith, sans-serif', label: 'Thasadith' },
  { value: 'Timmana, sans-serif', label: 'Timmana' },
  { value: 'Tinos, serif', label: 'Tinos' },
  { value: 'Titillium Web, sans-serif', label: 'Titillium Web' },
  { value: 'Tomorrow, sans-serif', label: 'Tomorrow' },
  { value: 'Tuffy, sans-serif', label: 'Tuffy' },
  { value: 'Ubuntu, sans-serif', label: 'Ubuntu' },
  { value: 'Ubuntu Condensed, sans-serif', label: 'Ubuntu Condensed' },
  { value: 'Varela, sans-serif', label: 'Varela' },
  { value: 'Varela Round, sans-serif', label: 'Varela Round' },
  { value: 'Voces, sans-serif', label: 'Voces' },
  { value: 'Voltaire, sans-serif', label: 'Voltaire' },
  { value: 'Work Sans, sans-serif', label: 'Work Sans' },
  { value: 'Yantramanav, sans-serif', label: 'Yantramanav' },
  { value: 'Zen Kaku Gothic Antique, sans-serif', label: 'Zen Kaku Gothic Antique' },
  { value: 'Zen Kaku Gothic New, sans-serif', label: 'Zen Kaku Gothic New' },
  { value: 'Zen Maru Gothic, sans-serif', label: 'Zen Maru Gothic' },
];

const loginFormAlignmentOptions = [
  { value: 'right', label: 'Right' },
  { value: 'center', label: 'Center' },
  { value: 'left', label: 'Left' },
];

const buttonStyleOptions = [
  { value: 'standard', label: 'Standard' },
  { value: 'rounded', label: 'Rounded' },
  { value: 'squared', label: 'Squared' },
];

const listLayoutOptions = [
  { value: 'table', label: 'Table View' },
  { value: 'card', label: 'Card View' },
  { value: 'table_card', label: 'Table / Card View' },
];

const getListLayoutOptionsForSla = (sla) =>
  listLayoutOptions.map((option) => ({
    ...option,
    isDisabled:
      sla === 'Standard'
        ? option.value !== 'table'
        : sla === 'Business Lite' || sla === 'Business'
          ? option.value === 'table_card'
          : false,
  }));

const SEMANTIC_ALERT_LOREM = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.';

const COLOR_FIELD_HELP_TEXT = {
  brandColor: 'Main brand accent for primary buttons, links, required badges, and the top navigation bar.',
  sidebarColor: 'Background color of the left navigation sidebar throughout the app.',
  infoColor: 'Release statuses such as Ready, Delivering, and In Progress, as well as informational alerts and buttons.',
  successColor: 'Save and Submit actions, success alerts, and other positive statuses such as paid or approved.',
  warningColor: 'Release statuses such as Pending, Submission Queued, Takedown request, and Re-delivery, as well as warning alerts and buttons.',
  dangerColor: 'Release statuses such as Taken down and Offline, error alerts, and destructive actions, as well as danger alerts and buttons.',
  scooterColor: 'Distributed release status badges and other scooter-styled UI accents.',
};

const SEMANTIC_SWATCH_COLORS = {
  info: [
    '#003f88', '#0056b3', '#007bff', '#028ee1', '#0369a1', '#075985', '#0c4a6e',
    '#0e7490', '#0f6674', '#138496', '#155e75', '#17a2b8', '#1d6a85', '#239eba',
    '#2bcfe0', '#006d77', '#00838f', '#0096c7', '#00b4d8', '#0891b2',
  ],
  success: [
    '#0a3622', '#0f5132', '#14532d', '#157347', '#166534', '#198754', '#1b5e20',
    '#2b9e62', '#28a745', '#047857', '#059669', '#065f46', '#134e4a', '#15803d',
    '#16a34a', '#1cc88a', '#10b981', '#22c55e', '#2e7d32', '#388e3c',
  ],
  warning: [
    '#78350f', '#7c2d12', '#854d0e', '#8a4b00', '#92400e', '#9a6700', '#a16207',
    '#b45309', '#c2410c', '#c77700', '#ca8a04', '#d97706', '#e65100', '#e8590c',
    '#ea580c', '#ef6c00', '#f57c00', '#f59e0b', '#f97316', '#ff9800',
  ],
  danger: [
    '#450a0a', '#58151c', '#7f1d1d', '#842029', '#880e4f', '#991b1b', '#9b1c1c',
    '#a71d2a', '#b71c1c', '#b91c1c', '#bd2130', '#c62828', '#c82333', '#cf1322',
    '#d32f2f', '#d50000', '#dc3545', '#e53935', '#e74a3b', '#ea2817',
  ],
  scooter: [
    '#004d40', '#004d53', '#006064', '#00695c', '#006d77', '#00796b', '#00838f',
    '#008080', '#00897b', '#0097a7', '#00acc1', '#00bcd4', '#17a2b8', '#1d6a85',
    '#20b2aa', '#24a1a1', '#26c6da', '#2bcfe0', '#48d1cc', '#5cdbd3',
  ],
};

const buildSemanticSwatches = (colors) =>
  [...new Set(colors.map((color) => color.toLowerCase()))].filter(
    (color) => !isLightColor(color),
  );

const semanticColorOptions = Object.fromEntries(
  Object.entries(SEMANTIC_SWATCH_COLORS).map(([key, colors]) => [
    key,
    buildSemanticSwatches(colors),
  ]),
);

const loadGoogleFont = (fontFamilyValue) => {
  try {
    const raw = (fontFamilyValue || '').split(',')[0].replace(/['"]/g, '').trim();
    if (!raw) return;
    const id = `gf-${raw.replace(/\s+/g, '-')}`;
    if (document.getElementById(id)) return;
    const urlFamily = `${raw.replace(/\s+/g, '+')}:wght@300;400;500;600;700`;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${urlFamily}&display=swap`;
    document.head.appendChild(link);
  } catch (e) {}
};

const isDirectAssetUrl = (url) => /^(https?:\/\/|blob:|data:)/i.test(url || '');

const toFullLogoUrl = (maybeRelative) => {
  if (!maybeRelative) return '';
  if (isDirectAssetUrl(maybeRelative)) return maybeRelative;
  const rel = (maybeRelative || '').replace(/^\//, '');
  const apiBase = String(API_URL || '').replace(/\/+$/, '');
  if (!apiBase) return `/${rel}`;
  return `${apiBase}/${rel}`;
};

const toRelativeLogoPath = (maybeFull) => {
  if (!maybeFull) return '';
  if (maybeFull.startsWith(API_URL)) {
    return maybeFull.replace(API_URL, '');
  }
  return maybeFull;
};

const generateRandomHex = (length) => {
  return [...Array(length)]
  .map(() => Math.floor(Math.random() * 16).toString(16))
  .join('');
};

const BrandingConfig = () => {
  const dispatch = useDispatch();
  const brandingState = useSelector(state => state.branding?.data || {});
  const token = getCookie("token");
  const { tenant, setTenant } = useContext(TenantContext);
  const { currentUser, setCurrentUser } = useContext(StateContext);
  const themeColorDefault = brandingState.first_color || DEFAULT_THEME_COLOR;
  const sidebarColorDefault =
    brandingState.sidebar_color_fe || DEFAULT_SIDEBAR_COLOR;
  const fontFamilyDefault = brandingState.font_family_fe || DEFAULT_FONT_FAMILY;
  const infoColorDefault = brandingState.info_color_fe || DEFAULT_INFO_COLOR;
  const successColorDefault = brandingState.success_color_fe || DEFAULT_SUCCESS_COLOR;
  const warningColorDefault = brandingState.warning_color_fe || DEFAULT_WARNING_COLOR;
  const dangerColorDefault = brandingState.danger_color_fe || DEFAULT_DANGER_COLOR;
  const scooterColorDefault = brandingState.scooter_color_fe || DEFAULT_SCOOTER_COLOR;
  const buttonStyleDefault = brandingState.button_style_fe || DEFAULT_BUTTON_STYLE;
  const listLayoutDefault = brandingState.list_layout_fe || DEFAULT_LIST_LAYOUT;

  const [brandColor, setBrandColor] = useState(themeColorDefault);
  const [sidebarColor, setSidebarColor] = useState(sidebarColorDefault);
  const [infoColor, setInfoColor] = useState(infoColorDefault);
  const [successColor, setSuccessColor] = useState(successColorDefault);
  const [warningColor, setWarningColor] = useState(warningColorDefault);
  const [dangerColor, setDangerColor] = useState(dangerColorDefault);
  const [scooterColor, setScooterColor] = useState(scooterColorDefault);
  const [buttonStyle, setButtonStyle] = useState(buttonStyleDefault);
  const [fontFamily, setFontFamily] = useState(fontFamilyDefault);
  const [activeColorPicker, setActiveColorPicker] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoImgUrl, setLogoImgUrl] = useState(null);
  const [pendingLogo, setPendingLogo] = useState('');

  const [logoTopbarPreview, setLogoTopbarPreview] = useState(null);
  const [logoImgUrlTopbar, setLogoImgUrlTopbar] = useState(null);
  const [pendingLogoTopbar, setPendingLogoTopbar] = useState('');

  /** Saved tenant logos only — previews mimic production until Save. */
  const [committedLoginPreviewLogoUrl, setCommittedLoginPreviewLogoUrl] = useState('');
  const [committedTopbarPreviewLogoUrl, setCommittedTopbarPreviewLogoUrl] = useState('');

  const [selectedFont, setSelectedFont] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);
  const [availableFonts] = useState(fontOptions);
  const [companyName, setCompanyName] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');
  const [helpCenterUrl, setHelpCenterUrl] = useState('');
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState('');
  const [cookiePolicyUrl, setCookiePolicyUrl] = useState('');
  const [termsAndConditionsUrl, setTermsAndConditionsUrl] = useState('');
  const [loginFormAlignment, setLoginFormAlignment] = useState(null);
  const [loginFormDisplayLogo, setLoginFormDisplayLogo] = useState(false);
  const [listLayout, setListLayout] = useState(listLayoutDefault);
  const [slaLevel, setSlaLevel] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [subscriptionsEnabled, setSubscriptionsEnabled] = useState(false);
  const [enableSubscriptionsModalOpen, setEnableSubscriptionsModalOpen] = useState(false);
  const [existingUsersHandling, setExistingUsersHandling] = useState(
    EXISTING_USERS_HANDLING.LEGACY
  );
  const [noDeploymentCredits, setNoDeploymentCredits] = useState(false);
  const [deploymentInProgress, setDeploymentInProgress] = useState(false);

  const fvRef = useRef();
  const colorPickerRefs = useRef({});
  const colorsSectionRef = useRef(null);
  const semanticColorsSectionRef = useRef(null);
  const buttonStylePreviewRef = useRef(null);

  useEffect(() => {
    if (currentUser && currentUser.sla_level) {
      setSlaLevel(currentUser.sla_level || null);
    }
    const hasDeploymentCredits = currentUser && currentUser.deployment_credits != null;
    if (hasDeploymentCredits) {
      setNoDeploymentCredits((Number(currentUser.deployment_credits) || 0) <= 0);
    } else {
      setNoDeploymentCredits(false);
    }

    let inProgress = false;
    // Demo branding applies instantly (session/mock) — skip the production 15-minute deploy lock.
    if (!isDemoLocked() && currentUser && currentUser.last_branding_updated) {
      const lastBrandingUpdate = new Date(currentUser.last_branding_updated);
      if (!Number.isNaN(lastBrandingUpdate.getTime())) {
        const now = new Date();
        const diffTime = Math.abs(now - lastBrandingUpdate);
        const diffMinutes = Math.ceil(diffTime / (1000 * 60));
        inProgress = diffMinutes <= 15;
      }
    }
    setDeploymentInProgress(inProgress);
  }, [currentUser]);

  useEffect(() => {
    setSubscriptionsEnabled(getSubscriptionsEnabled(tenant));
  }, [tenant]);

  const subscriptionsSlaEligible = isSubscriptionsSlaEligible(slaLevel);

  const handleSubscriptionsToggle = (checked) => {
    if (!subscriptionsSlaEligible) {
      return;
    }

    if (checked) {
      setExistingUsersHandling(EXISTING_USERS_HANDLING.LEGACY);
      setEnableSubscriptionsModalOpen(true);
      return;
    }

    setSubscriptionsEnabled(false);
  };

  const handleConfirmEnableSubscriptions = () => {
    setSubscriptionsEnabled(true);
    setEnableSubscriptionsModalOpen(false);
  };

  useEffect(() => {
    if (tenant && tenant.branding) {
      const tenantLogo = tenant.branding.logo || '';
      const tenantLogoTopbar = tenant.branding.logo_topbar_fe || '';
      const tenantPrimaryColor = tenant.branding.first_color || themeColorDefault;
      const tenantSidebarColor =
        tenant.branding.sidebar_color_fe || DEFAULT_SIDEBAR_COLOR;
      const tenantInfoColor = tenant.branding.info_color_fe || infoColorDefault;
      const tenantSuccessColor = tenant.branding.success_color_fe || successColorDefault;
      const tenantWarningColor = tenant.branding.warning_color_fe || warningColorDefault;
      const tenantDangerColor = tenant.branding.danger_color_fe || dangerColorDefault;
      const tenantScooterColor = tenant.branding.scooter_color_fe || scooterColorDefault;
      const tenantButtonStyle = tenant.branding.button_style_fe || buttonStyleDefault;
      const tenantFontFamily = tenant.branding.font_family_fe || fontFamilyDefault;
      const fontOption = (availableFonts || []).find(option => option.value === tenantFontFamily);

      setCompanyName(tenant.branding?.company || '');
      setCompanyWebsite(tenant.branding?.website || '');
      setHelpCenterUrl(tenant.help_center_url || '');

      setSelectedFont(fontOption || (availableFonts && availableFonts[0]) || null);

      const relativeLogo = toRelativeLogoPath(tenantLogo);
      const relativeLogoTopbar = toRelativeLogoPath(tenantLogoTopbar);
      setPendingLogo(relativeLogo);
      setPendingLogoTopbar(relativeLogoTopbar);
      setBrandColor(tenantPrimaryColor);
      setSidebarColor(tenantSidebarColor);
      setInfoColor(tenantInfoColor);
      setSuccessColor(tenantSuccessColor);
      setWarningColor(tenantWarningColor);
      setDangerColor(tenantDangerColor);
      setScooterColor(tenantScooterColor);
      setButtonStyle(tenantButtonStyle);
      setFontFamily(tenantFontFamily);
      loadGoogleFont(tenantFontFamily);
      setListLayout(tenant.branding.list_layout_fe || listLayoutDefault);
    }
    if (tenant) {
      setPrivacyPolicyUrl(tenant.privacy_policy_url || '');
      setCookiePolicyUrl(tenant.cookie_policy_url || '');
      setTermsAndConditionsUrl(tenant.terms_and_conditions_url || '');
    }

    if (slaLevel && tenant && tenant.branding) {
      if (slaLevel === "Standard" || slaLevel === "Business Lite") {
        if (slaLevel === "Standard") {
          setLoginFormDisplayLogo(false);
          setLoginFormAlignment("center");
          setListLayout('table');
        }
        else if (slaLevel === "Business Lite") {
          setLoginFormDisplayLogo(tenant.branding.display_logo || true);
          setLoginFormAlignment("center");
        }
      }
      else {
        setLoginFormDisplayLogo(tenant.branding.display_logo || true);
        setLoginFormAlignment(tenant.branding.form_alignment_fe || null);
      }
    }
  }, [tenant, availableFonts, slaLevel]);

  useEffect(() => {
    let cancelled = false;
    const rel = toRelativeLogoPath(tenant?.branding?.logo || '');
    resolveBrandingLogoObjectUrl(rel).then(url => {
      if (cancelled) {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
        return;
      }
      setCommittedLoginPreviewLogoUrl(prev => {
        if (prev && prev.startsWith('blob:') && prev !== url) {
          URL.revokeObjectURL(prev);
        }
        return url || '';
      });
    });
    return () => {
      cancelled = true;
    };
  }, [tenant?.branding?.logo]);

  useEffect(() => {
    let cancelled = false;
    const rel = toRelativeLogoPath(tenant?.branding?.logo_topbar_fe || '');
    resolveBrandingLogoObjectUrl(rel).then(url => {
      if (cancelled) {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
        return;
      }
      setCommittedTopbarPreviewLogoUrl(prev => {
        if (prev && prev.startsWith('blob:') && prev !== url) {
          URL.revokeObjectURL(prev);
        }
        return url || '';
      });
    });
    return () => {
      cancelled = true;
    };
  }, [tenant?.branding?.logo_topbar_fe]);

  useEffect(() => {
    if (logoPreview || !(tenant?.branding)) {
      return undefined;
    }
    let cancelled = false;
    const rel = toRelativeLogoPath(tenant.branding.logo || '');
    resolveBrandingLogoObjectUrl(rel).then(url => {
      if (cancelled) {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
        return;
      }
      setLogoImgUrl(url || '');
    });
    return () => {
      cancelled = true;
    };
  }, [tenant?.branding?.logo, logoPreview]);

  useEffect(() => {
    if (logoTopbarPreview || !(tenant?.branding)) {
      return undefined;
    }
    let cancelled = false;
    const rel = toRelativeLogoPath(tenant.branding.logo_topbar_fe || '');
    resolveBrandingLogoObjectUrl(rel).then(url => {
      if (cancelled) {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
        return;
      }
      setLogoImgUrlTopbar(url || '');
    });
    return () => {
      cancelled = true;
    };
  }, [tenant?.branding?.logo_topbar_fe, logoTopbarPreview]);

  useEffect(() => {
    const formEl = document.getElementById('brandingForm');
    if (!formEl) return;

    const fv = formValidation(formEl, opt);
    fvRef.current = fv;

    return () => {
      if (fvRef.current && fvRef.current.destroy) {
        fvRef.current.destroy();
        fvRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined' || !document.documentElement) {
      return;
    }
    applyBrandingCssVars(document.documentElement, {
      themeColor: brandColor,
      sidebarColor,
      infoColor,
      successColor,
      warningColor,
      dangerColor,
      scooterColor,
      buttonStyle,
    });
    document.documentElement.style.setProperty("--tenant-font-family", fontFamily);
  }, [
    brandColor,
    sidebarColor,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    scooterColor,
    buttonStyle,
    fontFamily,
  ]);

  useEffect(() => {
    setRuntimeReleaseListLayoutConfig(listLayout);
  }, [listLayout]);

  useEffect(() => {
    if (!logoPreview) {
      return undefined;
    }
    let objectUrl = null;
    try {
      objectUrl = URL.createObjectURL(logoPreview);
      setLogoImgUrl(objectUrl);
    } catch (e) {}
    return () => {
      if (objectUrl) {
        try {
          URL.revokeObjectURL(objectUrl);
        } catch (e2) {}
      }
    };
  }, [logoPreview]);


  useEffect(() => {
    if (!logoTopbarPreview) {
      return undefined;
    }
    let objectUrl = null;
    try {
      objectUrl = URL.createObjectURL(logoTopbarPreview);
      setLogoImgUrlTopbar(objectUrl);
    } catch (e) {}
    return () => {
      if (objectUrl) {
        try {
          URL.revokeObjectURL(objectUrl);
        } catch (e2) {}
      }
    };
  }, [logoTopbarPreview]);

  useEffect(() => {
    if (!activeColorPicker) return undefined;

    const handlePointerDown = (event) => {
      const container = colorPickerRefs.current[activeColorPicker];
      if (container && !container.contains(event.target)) {
        setActiveColorPicker(null);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [activeColorPicker]);

  useEffect(() => {
    const brandingVars = {
      themeColor: brandColor,
      sidebarColor,
      infoColor,
      successColor,
      warningColor,
      dangerColor,
      scooterColor,
      buttonStyle,
    };
    [colorsSectionRef.current, semanticColorsSectionRef.current, buttonStylePreviewRef.current].forEach((el) => {
      if (el) {
        applyBrandingCssVars(el, brandingVars);
      }
    });
  }, [
    brandColor,
    sidebarColor,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    scooterColor,
    buttonStyle,
  ]);

  useEffect(() => {
    const initialLogo = toRelativeLogoPath(tenant?.branding?.logo || '');
    const initialLogoTopbar = toRelativeLogoPath(tenant?.branding?.logo_topbar_fe || '');
    const initialColor = tenant?.branding?.first_color || themeColorDefault;
    const initialSidebarColor =
      tenant?.branding?.sidebar_color_fe || DEFAULT_SIDEBAR_COLOR;
    const initialInfoColor = tenant?.branding?.info_color_fe || infoColorDefault;
    const initialSuccessColor = tenant?.branding?.success_color_fe || successColorDefault;
    const initialWarningColor = tenant?.branding?.warning_color_fe || warningColorDefault;
    const initialDangerColor = tenant?.branding?.danger_color_fe || dangerColorDefault;
    const initialScooterColor = tenant?.branding?.scooter_color_fe || scooterColorDefault;
    const initialButtonStyle = tenant?.branding?.button_style_fe || buttonStyleDefault;
    const initialFont = tenant?.branding?.font_family_fe || fontFamilyDefault;
    const initialLoginFormAlignment = tenant?.branding?.form_alignment_fe || null;
    const initialLoginFormDisplayLogo = tenant?.branding?.logo_visible_fe || false;
    const initialListLayout = tenant?.branding?.list_layout_fe || listLayoutDefault;
    const initialCompanyName = tenant?.company || '';
    const initialCompanyWebsite = tenant?.website || '';
    const initialPrivacyPolicyUrl = tenant?.privacy_policy_url || '';
    const initialCookiePolicyUrl = tenant?.cookie_policy_url || '';
    const initialHelpCenterUrl = tenant?.help_center_url || '';
    const initialTermsAndConditionsUrl = tenant?.terms_and_conditions_url || '';
    const initialSubscriptionsEnabled = getSubscriptionsEnabled(tenant);

    const changed =
      ((pendingLogo && pendingLogo !== initialLogo)) ||
      (pendingLogoTopbar && pendingLogoTopbar !== initialLogoTopbar) ||
      (brandColor && brandColor !== initialColor) ||
      (sidebarColor && sidebarColor !== initialSidebarColor) ||
      (infoColor && infoColor !== initialInfoColor) ||
      (successColor && successColor !== initialSuccessColor) ||
      (warningColor && warningColor !== initialWarningColor) ||
      (dangerColor && dangerColor !== initialDangerColor) ||
      (scooterColor && scooterColor !== initialScooterColor) ||
      (buttonStyle && buttonStyle !== initialButtonStyle) ||
      (fontFamily && fontFamily !== initialFont) ||
      (loginFormAlignment !== initialLoginFormAlignment) ||
      (loginFormDisplayLogo !== initialLoginFormDisplayLogo) ||
      (listLayout !== initialListLayout) ||
      (companyName !== initialCompanyName) ||
      (companyWebsite !== initialCompanyWebsite) ||
      (privacyPolicyUrl !== initialPrivacyPolicyUrl) ||
      (cookiePolicyUrl !== initialCookiePolicyUrl) ||
      (helpCenterUrl !== initialHelpCenterUrl) ||
      (termsAndConditionsUrl !== initialTermsAndConditionsUrl) ||
      (subscriptionsEnabled !== initialSubscriptionsEnabled);

    setHasChanges(!!changed);
  }, [pendingLogo, pendingLogoTopbar, brandColor, sidebarColor, infoColor, successColor, warningColor, dangerColor, scooterColor, buttonStyle, fontFamily, loginFormAlignment, loginFormDisplayLogo, listLayout, companyName, companyWebsite, privacyPolicyUrl, cookiePolicyUrl, helpCenterUrl, termsAndConditionsUrl, subscriptionsEnabled, tenant, themeColorDefault, fontFamilyDefault, infoColorDefault, successColorDefault, warningColorDefault, dangerColorDefault, scooterColorDefault, buttonStyleDefault, listLayoutDefault]);

  useEffect(() => {
    if (hasChanges && success) {
      setSuccess(false);
    }
  }, [hasChanges, success]);

  const handleLogoUpload = (file, kind) => {
    if (!file) return;

    if (kind === 'logo') {
      setLogoPreview(file);
    } else {
      setLogoTopbarPreview(file);
    }

    if (isDemoMode() || isBrowserSessionDemo()) {
      setLoading(true);
      const storageKey = `tenant_logo_${kind}_${generateRandomHex(12)}`;
      putDemoTrackBlob(storageKey, file)
        .then(() => {
          const ref = `${WL_DEMO_BLOB_PREFIX}${encodeURIComponent(storageKey)}`;
          if (kind === 'logo') {
            setPendingLogo(ref);
          } else {
            setPendingLogoTopbar(ref);
          }
          setLoading(false);
        })
        .catch(err => {
          console.warn(err);
          setError(true);
          setLoading(false);
        });
      return;
    }

    const uploadDestination = kind === 'logo' ? 'tenant_logos' : 'tenant_logos_fe';

    setLoading(true);
    const lastDot = file.name.lastIndexOf('.');
    const fileExt = lastDot >= 0 ? file.name.slice(lastDot + 1).toLowerCase() : '';
    if (!fileExt) {
      setError(true);
      setLoading(false);
      return;
    }
    const fileName = generateRandomHex(10);
    const mime =
      file.type ||
      (fileExt === 'jpg' || fileExt === 'jpeg'
        ? 'image/jpeg'
        : fileExt === 'png'
          ? 'image/png'
          : fileExt === 'gif'
            ? 'image/gif'
            : fileExt === 'webp'
              ? 'image/webp'
              : 'application/octet-stream');

    axios({
      method: "GET",
      mode: 'cors',
      url: `${API_URL}obtain-signed-url-for-upload/?filename=media/${uploadDestination}/${fileName}.${fileExt}&filetype=${fileExt}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": X_API_KEY,
      }
    }).then(function(response) {
      const signedUploadUrl = response.data.signed_url.url;
      const full_URL = response.data.signed_url.fields.key;
      let split = (full_URL || '').split('/');
      split.shift();
      let transformedURL = split.join('/');

      const signedOpts = response.data.signed_url.fields;
      var options = {
        mode: 'cors',
        headers: {
          "Content-Type": mime
        }
      };
      var postData = new FormData();
      for (let i in signedOpts) {
        postData.append(i, signedOpts[i]);
      }
      postData.append("file", file);

      axios
        .post(signedUploadUrl, postData, options)
        .then(result => {
          const relative = toRelativeLogoPath(transformedURL);
          if (kind === 'logo') {
            setPendingLogo(relative);
          } else {
            setPendingLogoTopbar(relative);
          }
          setLoading(false);
        })
        .catch(error => {
          console.log("ERROR " + error);
          setError(true);
          setLoading(false);
        });
    }).catch(error => {
      console.log("ERROR " + error);
      setError(true);
      setLoading(false);
    });
  };

  const handleColorChange = (color) => {
    setBrandColor(color.hex);
  };

  const revalidateColorField = (fieldName) => {
    if (fvRef.current && fvRef.current.revalidateField) {
      setTimeout(() => {
        if (fvRef.current) {
          fvRef.current.revalidateField(fieldName);
        }
      }, 0);
    }
  };

  const assignColorPickerRef = (pickerKey) => (node) => {
    if (node) {
      colorPickerRefs.current[pickerKey] = node;
    } else {
      delete colorPickerRefs.current[pickerKey];
    }
  };

  const toggleColorPicker = (pickerKey) => {
    setActiveColorPicker((current) => (current === pickerKey ? null : pickerKey));
  };

  const renderColorPickerField = ({
    title,
    pickerKey,
    color,
    setColor,
    fieldName,
    placeholder,
    presetColors,
    onInputChange,
    wrapInCol = true,
    hideTitle = false,
    helpText,
  }) => {
    const field = (
      <div className={wrapInCol ? undefined : 'branding-semantic-color-field'}>
        {!hideTitle && <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>{title}</h6>}
        <FormGroup className="mb-0">
          <div ref={assignColorPickerRef(pickerKey)} className="branding-color-picker-group">
            <div className="color-picker-container" style={{ display: 'flex', alignItems: 'center' }}>
              <div
                className="color-swatch"
                style={{ backgroundColor: color }}
                onClick={() => toggleColorPicker(pickerKey)}
              />
              <Input
                type="text"
                name={fieldName}
                pattern="#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})"
                value={color}
                onChange={(e) => {
                  setColor(e.target.value);
                  if (onInputChange) {
                    onInputChange(e.target.value);
                  }
                  revalidateColorField(fieldName);
                }}
                placeholder={placeholder}
                style={{ flex: 1, minWidth: 0, marginLeft: '12px' }}
              />
            </div>
            {activeColorPicker === pickerKey && (
              <div className="branding-color-picker-dropdown">
                {renderBrandingColorPicker(color, setColor, fieldName, presetColors)}
              </div>
            )}
          </div>
        </FormGroup>
        {helpText && (
          <FormText color="muted" className="branding-colors-help-text">
            {helpText}
          </FormText>
        )}
      </div>
    );

    if (!wrapInCol) {
      return field;
    }

    return (
      <Col sm={12} md={6} lg={6} xl={6} className="mt-3">
        {field}
      </Col>
    );
  };

  const renderBrandingColorPicker = (color, setColor, fieldName, colors) => {
    const handlePickerChange = (nextColor) => {
      setColor(nextColor.hex);
      revalidateColorField(fieldName);
    };

    return (
      <div style={{ display: "flex", alignItems: "right", width: "100%" }}>
        <ChromePicker
          color={color}
          onChange={handlePickerChange}
          disableAlpha={true}
        />
        <TwitterPicker
          color={color}
          onChange={handlePickerChange}
          colors={colors}
          triangle="hide"
        />
      </div>
    );
  };

  const handleSave = () => {
    if (fvRef.current && fvRef.current.validate) {
      fvRef.current.validate().then((status) => {
        if (status === 'Valid') {
          setConfirmModalOpen(true);
        }
      });
    } else {
      setConfirmModalOpen(true);
    }
  };

  const performSave = () => {
    setConfirmModalOpen(false);
    setLoading(true);

    const initialLogo = toRelativeLogoPath(tenant?.branding?.logo || '');
    const initialLogoTopbar = toRelativeLogoPath(tenant?.branding?.logo_topbar_fe || '');
    const initialColor = tenant?.branding?.first_color || themeColorDefault;
    const initialSidebarColor =
      tenant?.branding?.sidebar_color_fe || DEFAULT_SIDEBAR_COLOR;
    const initialInfoColor = tenant?.branding?.info_color_fe || infoColorDefault;
    const initialSuccessColor = tenant?.branding?.success_color_fe || successColorDefault;
    const initialWarningColor = tenant?.branding?.warning_color_fe || warningColorDefault;
    const initialDangerColor = tenant?.branding?.danger_color_fe || dangerColorDefault;
    const initialScooterColor = tenant?.branding?.scooter_color_fe || scooterColorDefault;
    const initialButtonStyle = tenant?.branding?.button_style_fe || buttonStyleDefault;
    const initialFont = tenant?.branding?.font_family_fe || fontFamilyDefault;
    const initialCompanyName = tenant?.branding?.company || '';
    const initialCompanyWebsite = tenant?.branding?.website || '';

    const initialLoginFormAlignment = tenant?.branding?.form_alignment_fe || null;
    const initialLoginFormDisplayLogo = tenant?.branding?.logo_visible_fe || false;
    const initialListLayout = tenant?.branding?.list_layout_fe || listLayoutDefault;

    const initialPrivacyPolicyUrl = tenant?.privacy_policy_url || '';
    const initialCookiePolicyUrl = tenant?.cookie_policy_url || '';
    const initialTermsAndConditionsUrl = tenant?.terms_and_conditions_url || '';

    const updateData = {};
    const brandingUpdates = {};
    if (pendingLogo && pendingLogo !== initialLogo) {
      brandingUpdates.logo = toRelativeLogoPath(pendingLogo);
    }
    if (pendingLogoTopbar && pendingLogoTopbar !== initialLogoTopbar) {
      brandingUpdates.logo_topbar_fe = toRelativeLogoPath(pendingLogoTopbar);
    }
    if (brandColor && brandColor !== initialColor) {
      brandingUpdates.first_color = brandColor;
    }
    if (sidebarColor && sidebarColor !== initialSidebarColor) {
      brandingUpdates.sidebar_color_fe = sidebarColor;
    }
    if (infoColor && infoColor !== initialInfoColor) {
      brandingUpdates.info_color_fe = infoColor;
    }
    if (successColor && successColor !== initialSuccessColor) {
      brandingUpdates.success_color_fe = successColor;
    }
    if (warningColor && warningColor !== initialWarningColor) {
      brandingUpdates.warning_color_fe = warningColor;
    }
    if (dangerColor && dangerColor !== initialDangerColor) {
      brandingUpdates.danger_color_fe = dangerColor;
    }
    if (scooterColor && scooterColor !== initialScooterColor) {
      brandingUpdates.scooter_color_fe = scooterColor;
    }
    if (buttonStyle && buttonStyle !== initialButtonStyle) {
      brandingUpdates.button_style_fe = buttonStyle;
    }
    if (fontFamily && fontFamily !== initialFont) {
      brandingUpdates.font_family_fe = fontFamily;
    }
    if (companyName !== initialCompanyName) {
      brandingUpdates.company = companyName;
    }
    if (companyWebsite !== initialCompanyWebsite) {
      brandingUpdates.website = companyWebsite;
    }
    if (loginFormAlignment !== initialLoginFormAlignment) {
      brandingUpdates.form_alignment_fe = loginFormAlignment;
    }
    if (loginFormDisplayLogo !== initialLoginFormDisplayLogo) {
      brandingUpdates.logo_visible_fe = loginFormDisplayLogo;
    }
    if (listLayout !== initialListLayout) {
      brandingUpdates.list_layout_fe = listLayout;
    }
    if (Object.keys(brandingUpdates).length > 0) {
      updateData.branding = brandingUpdates;
    }
    if (helpCenterUrl !== (tenant?.help_center_url || '')) {
      updateData.help_center_url = helpCenterUrl;
    }
    if (privacyPolicyUrl !== initialPrivacyPolicyUrl) {
      updateData.privacy_policy_url = privacyPolicyUrl;
    }
    if (cookiePolicyUrl !== initialCookiePolicyUrl) {
      updateData.cookie_policy_url = cookiePolicyUrl;
    }
    if (termsAndConditionsUrl !== initialTermsAndConditionsUrl) {
      updateData.terms_and_conditions_url = termsAndConditionsUrl;
    }

    const initialSubscriptionsEnabled = getSubscriptionsEnabled(tenant);
    if (subscriptionsEnabled !== initialSubscriptionsEnabled) {
      updateData.subscriptions_enabled = subscriptionsEnabled;
      if (subscriptionsEnabled) {
        updateData.existing_users_transition = existingUsersHandling;
      }
    }

    if(slaLevel !== "gold" && tenant.google_oauth) {
      updateData.google_oauth = false;
    }

    if (Object.keys(updateData).length === 0) {
      setLoading(false);
      return;
    }

    axios({
      method: "POST",
      url: `${API_URL}tenant-branding-update/`,
      data: updateData,
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": X_API_KEY,
      }
    }).then((response) => {
      if (response.status !== 200) {
        setError(true);
        setLoading(false);
        return;
      }

      const optimisticTenant = {
        ...(tenant || {}),
        ...(updateData || {}),
        branding: {
          ...((tenant && tenant.branding) || {}),
          ...(brandingUpdates || {}),
        },
      };
      setTenant(optimisticTenant);
      dispatch(updateBranding(optimisticTenant.branding || {}));
      setLogoPreview(null);
      setLogoTopbarPreview(null);

      const hasDeploymentCredits = currentUser && currentUser.deployment_credits != null;
      const currentCredits = hasDeploymentCredits ? (Number(currentUser?.deployment_credits) || 0) : null;
      const optimisticUser = {
        ...(currentUser || {}),
        ...(hasDeploymentCredits
          ? { deployment_credits: currentCredits > 0 ? currentCredits - 1 : 0 }
          : {}),
        last_branding_updated: new Date().toISOString(),
      };
      setCurrentUser(optimisticUser);
      dispatch(updateProfile(optimisticUser));
      if (hasDeploymentCredits) {
        setNoDeploymentCredits((Number(optimisticUser.deployment_credits) || 0) <= 0);
      } else {
        setNoDeploymentCredits(false);
      }
      setDeploymentInProgress(!isDemoLocked());
      setHasChanges(false);
      setSuccess(true);

      // Do not immediately refetch tenant branding here: backend propagation may lag and
      // return stale branding, which would overwrite the just-saved realtime UI state.

      if (currentUser && currentUser.id) {
        axios({
          method: "GET",
          url: `${API_URL}users/${currentUser.id}/`,
          mode: 'cors',
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": X_API_KEY,
          }
        }).then((userResponse) => {
          if (userResponse.status === 200) {
            setCurrentUser(userResponse.data);
            dispatch(updateProfile(userResponse.data));
            setNoDeploymentCredits((Number(userResponse.data?.deployment_credits) || 0) <= 0);
          }
        });
      }

      setLoading(false);
    }).catch(error => {
      console.log("ERROR " + error);
      setError(true);
      setLoading(false);
      // setTimeout(() => setError(false), 5000);
    });
  };

  const handleReset = () => {
    setBrandColor(themeColorDefault);
    setSidebarColor(sidebarColorDefault);
    setInfoColor(infoColorDefault);
    setSuccessColor(successColorDefault);
    setWarningColor(warningColorDefault);
    setDangerColor(dangerColorDefault);
    setScooterColor(scooterColorDefault);
    setButtonStyle(buttonStyleDefault);
    setFontFamily(fontFamilyDefault);
    setLogoPreview('');
    setLogoTopbarPreview('');
    setPendingLogo('');
    setPendingLogoTopbar('');
    dispatch(updateBranding({
      logo_topbar_fe: toRelativeLogoPath(tenant?.branding?.logo_topbar_fe || ''),
    }));
    setSelectedFont((availableFonts && availableFonts[0]) || null);
    setCompanyName(tenant?.branding?.company || '');
    setCompanyWebsite(tenant?.branding?.website || '');
    setHelpCenterUrl(tenant?.help_center_url || '');
    setPrivacyPolicyUrl(tenant?.privacy_policy_url || '');
    setCookiePolicyUrl(tenant?.cookie_policy_url || '');
    setTermsAndConditionsUrl(tenant?.terms_and_conditions_url || '');
    setSubscriptionsEnabled(getSubscriptionsEnabled(tenant));
    setExistingUsersHandling(EXISTING_USERS_HANDLING.LEGACY);
    setEnableSubscriptionsModalOpen(false);

    if (slaLevel && tenant && tenant.branding) {
      if (slaLevel === "Standard" || slaLevel === "Business Lite") {
        if (slaLevel === "Standard") {
          setLoginFormDisplayLogo(false);
          setLoginFormAlignment("center");
        }
        else if (slaLevel === "Business Lite") {
          setLoginFormDisplayLogo(tenant.branding.display_logo || true);
          setLoginFormAlignment("center");
        }
      }
      else {
        setLoginFormDisplayLogo(tenant.branding.display_logo || true);
        setLoginFormAlignment(tenant.branding.form_alignment_fe || null);
      }
    }
    setListLayout(tenant?.branding?.list_layout_fe || listLayoutDefault);
    if (slaLevel === 'Standard') {
      setListLayout('table');
    }
  };

  return (
    <div className="container-fluid branding-container">
      <LoaderInner show={loading} />
      {
        noDeploymentCredits && (
          <Alert color="danger">
            You do not have any deployment credits to update the branding. Please <a href="/deployment-credits/order">purchase deployment credits</a> in order to update the branding.
          </Alert>
        )
      }
      {
        deploymentInProgress && (
          <Alert color="info">
            A branding update is in progress. Please wait for it to complete. It usually takes upto 15 minutes.
          </Alert>
        )
      }
      <Row>
        <Col sm={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Brand Configuration</CardTitle>
              <p className="text-muted">Customize app appearance.</p>
            </CardHeader>
            <CardBody>
              <Form id="brandingForm">
                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Logo</h4>
                <Row className="branding-paired-row">
                  <Col sm={12} md={6} lg={6} xl={6}>
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>Topbar</h6>
                    <FormGroup>
                      <CustomInput
                        type="file"
                        id="logoTopbar"
                        name="logoTopbar"
                        accept=".png"
                        onChange={(e) => handleLogoUpload(e.target.files[0], 'logoTopbar')}
                        disabled={loading}
                      />
                      <small className="text-muted">
                        Recommended size: 200x60px. Supported format: PNG<br/>
                        <strong>Note:</strong> This logo is used on the topbar of the app please choose matching logo color with the primary color for best visibility.
                      </small>
                    </FormGroup>
                    
                    {logoImgUrlTopbar && (
                      <div className="mt-3">
                        <div className="logo-preview" style={{ maxWidth: '200px', "--theme-color": brandColor }}>
                          <img 
                            src={logoImgUrlTopbar} 
                            alt="Logo preview" 
                            style={{ maxWidth: '100%', height: 'auto'}}
                            onError={(e) => {
                              console.error('Logo preview failed to load:', logoImgUrlTopbar);
                              e.target.style.display = 'none';
                            }}
                            onLoad={() => {
                              console.log('Logo preview loaded successfully:', logoImgUrlTopbar);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </Col>

                  <Col sm={12} md={6} lg={6} xl={6}>
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>Email & Login</h6>
                    <FormGroup>
                      <CustomInput
                        type="file"
                        id="logo"
                        name="logo"
                        accept=".png"
                        onChange={(e) => handleLogoUpload(e.target.files[0], 'logo')}
                        disabled={loading}
                      />
                      <small className="text-muted">
                        Recommended size: 200x60px. Supported format: PNG<br/>
                        <strong>Note:</strong> This logo is used on the login form and email on white background please choose a logo with dark colors and trasparent background.
                      </small>
                    </FormGroup>
                    
                    {logoImgUrl && (
                      <div className="mt-3">
                        <div className="logo-preview" style={{ maxWidth: '200px', "--theme-color": brandColor }}>
                          <img 
                            src={logoImgUrl} 
                            alt="Logo preview" 
                            style={{ maxWidth: '100%', height: 'auto'}}
                            onError={(e) => {
                              console.error('Logo preview failed to load:', logoImgUrl);
                              e.target.style.display = 'none';
                            }}
                            onLoad={() => {
                              console.log('Logo preview loaded successfully:', logoImgUrl);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>

                <hr style={BRANDING_SECTION_DIVIDER_STYLE} />

                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Brand Colors</h4>
                <div ref={colorsSectionRef} className="branding-colors-panel branding-brand-colors-panel">
                  <Row className="branding-colors-row branding-paired-row">
                    <Col sm={12} md={6} lg={6} xl={6} className="branding-color-field-col">
                      {renderColorPickerField({
                        title: 'Primary Color',
                        pickerKey: 'brand',
                        color: brandColor,
                        setColor: setBrandColor,
                        fieldName: 'brandColor',
                        placeholder: themeColorDefault,
                        onInputChange: (value) => handleColorChange({ hex: value }),
                        wrapInCol: false,
                        helpText: COLOR_FIELD_HELP_TEXT.brandColor,
                      })}
                      <Alert color="primary" className="branding-preview-alert branding-preview-alert-primary">
                        <strong>Primary.</strong> {SEMANTIC_ALERT_LOREM}
                      </Alert>
                    </Col>
                    <Col sm={12} md={6} lg={6} xl={6} className="branding-color-field-col">
                      {renderColorPickerField({
                        title: 'Sidebar Color',
                        pickerKey: 'sidebar',
                        color: sidebarColor,
                        setColor: setSidebarColor,
                        fieldName: 'sidebarColor',
                        placeholder: sidebarColorDefault,
                        wrapInCol: false,
                        helpText: COLOR_FIELD_HELP_TEXT.sidebarColor,
                      })}
                    </Col>
                  </Row>
                </div>

                <hr style={BRANDING_SECTION_DIVIDER_STYLE} />

                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Font and Button Style</h4>
                <Row className="branding-paired-row">
                  <Col sm={12} md={6} lg={6} xl={6} className="branding-select-field">
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>Font Family</h6>
                    <FormGroup className="mb-0">
                      <div className="branding-select-control">
                        <Select
                          components={{ IndicatorSeparator:() => null }}
                          name="fontFamily"
                          id="fontFamily"
                          options={availableFonts}
                          value={selectedFont}
                          onChange={(selectedOption) => {
                            setSelectedFont(selectedOption);
                            setFontFamily(selectedOption.value);
                            loadGoogleFont(selectedOption.value);
                          }}
                          placeholder="Select a font..."
                          isSearchable
                          maxMenuHeight={320}
                        />
                      </div>
                      {/* <div className="mt-5">
                      <h5>Font Preview</h5>
                        <div 
                          className="font-preview"
                          style={{
                            fontFamily: fontFamily,
                            color: brandColor,
                            "--theme-color": brandColor,
                          }}
                        >
                          <div>
                            <h3 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '600' }}>
                              {tenant?.name || 'Your Brand Name'}
                            </h3>
                            <p style={{ margin: '0 0 4px 0', fontSize: '16px', opacity: '0.9' }}>
                              The quick brown fox jumps over the lazy dog
                            </p>
                            <p style={{ margin: '0', fontSize: '14px', opacity: '0.7' }}>
                              ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789
                            </p>
                          </div>
                        </div>
                      </div> */}
                    </FormGroup>
                  </Col>

                  <Col sm={12} md={6} lg={6} xl={6} className="branding-select-field">
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>Button Style</h6>
                    <FormGroup className="mb-0">
                      <div className="branding-select-control">
                        <Select
                          id="buttonStyle"
                          value={buttonStyleOptions.find(option => option.value === buttonStyle) || buttonStyleOptions[0]}
                          options={buttonStyleOptions}
                          onChange={(selectedOption) => setButtonStyle(selectedOption.value)}
                          components={{ IndicatorSeparator:() => null }}
                        />
                      </div>
                    </FormGroup>
                    <div
                      ref={buttonStylePreviewRef}
                      className="branding-button-style-preview mt-3"
                      style={{ '--branding-preview-button-radius': getButtonBorderRadius(buttonStyle) }}
                    >
                      {[
                        { className: 'btn-primary', label: 'Primary' },
                        { className: 'btn-success', label: 'Success' },
                        { className: 'btn-info', label: 'Info' },
                        { className: 'btn-warning', label: 'Warning' },
                        { className: 'btn-danger', label: 'Danger' },
                        { className: 'btn-scooter', label: 'Scooter' },
                      ].map(({ className, label }) => (
                        <Button
                          key={className}
                          className={`btn ${className} branding-button-style-preview-btn`}
                          type="button"
                        >
                          {label}
                        </Button>
                      ))}
                    </div>
                  </Col>
                </Row>

                <hr style={BRANDING_SECTION_DIVIDER_STYLE} />

                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Login Form</h4>
                <Row className="branding-paired-row">
                  <Col sm={12} md={6} lg={6} xl={6} className="branding-select-field">
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>Form Alignment</h6>
                    <FormGroup className="mb-0">
                      <div className="branding-select-control">
                        <Select
                          id="loginFormAlignment"
                          value={loginFormAlignmentOptions.find(option => option.value === loginFormAlignment) || null}
                          options={loginFormAlignmentOptions}
                          onChange={(selectedOption) => setLoginFormAlignment(selectedOption.value)}
                          components={{ IndicatorSeparator:() => null }}
                          isDisabled={slaLevel === "Standard" || slaLevel === "Business Lite"}
                        />
                      </div>
                    </FormGroup>
                    {(slaLevel === "Standard" || slaLevel === "Business Lite") && (
                    <FormText color="muted">
                        This feature is not available in your current <Link to="/sla">SLA level</Link>. Please <Link to="/sla">upgrade</Link> to a higher <Link to="/sla">SLA level</Link> to use this feature.
                    </FormText>
                    )}
                  </Col>

                  <Col sm={12} md={6} lg={6} xl={6}>
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>Form Logo Visibility</h6>
                    <CustomInput
                      type="checkbox"
                      id="loginFormDisplayLogo"
                      checked={loginFormDisplayLogo}
                      onChange={(e) => setLoginFormDisplayLogo(!!e.target.checked)}
                      disabled={slaLevel === "Standard"}
                    />
                    {(slaLevel === "Standard") && (
                      <FormText color="muted">
                        This feature is not available in your current <Link to="/sla">SLA level</Link>. Please <Link to="/sla">upgrade</Link> to a higher <Link to="/sla">SLA level</Link> to use this feature.
                      </FormText>
                    )}
                  </Col>
                </Row>

                <Row className="branding-paired-row mt-3">
                  <Col sm={12} md={6} lg={6} xl={6} className="branding-select-field">
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}> List Layout</h6>
                    <FormGroup className="mb-0">
                      <div className="branding-select-control">
                        <Select
                          id="listLayout"
                          value={listLayoutOptions.find((option) => option.value === listLayout) || listLayoutOptions[0]}
                          options={getListLayoutOptionsForSla(slaLevel)}
                          onChange={(selectedOption) => setListLayout(selectedOption.value)}
                          components={{ IndicatorSeparator: () => null }}
                          isDisabled={slaLevel === 'Standard'}
                          isOptionDisabled={(option) => option.isDisabled}
                        />
                      </div>
                    </FormGroup>
                    <FormText color="muted">
                      Note: This option is available for Release list only.
                    </FormText>
                    {slaLevel === 'Standard' && (
                      <FormText color="muted">
                        This feature is not available in your current <Link to="/sla">SLA level</Link>. Please <Link to="/sla">upgrade</Link> to a higher <Link to="/sla">SLA level</Link> to use this feature.
                      </FormText>
                    )}
                    {(slaLevel === 'Business Lite' || slaLevel === 'Business') && listLayout === 'table_card' && (
                      <FormText color="muted">
                        Table / Card View is not available in your current <Link to="/sla">SLA level</Link>. Please <Link to="/sla">upgrade</Link> to Gold to use this option.
                      </FormText>
                    )}
                  </Col>
                </Row>

                <hr style={BRANDING_SECTION_DIVIDER_STYLE} />

                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Preview</h4>
                <Row className="branding-paired-row">
                  <Col md={6} sm={12} className="mb-2">
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>App Preview</h6>
                    <BrandingPreview
                      brandColor={brandColor}
                      sidebarColor={sidebarColor}
                      infoColor={infoColor}
                      successColor={successColor}
                      warningColor={warningColor}
                      dangerColor={dangerColor}
                      scooterColor={scooterColor}
                      buttonStyle={buttonStyle}
                      fontFamily={fontFamily}
                      logoUrl={committedTopbarPreviewLogoUrl}
                      companyName={companyName}
                      companyWebsite={companyWebsite}
                      helpCenterUrl={helpCenterUrl}
                      privacyPolicyUrl={privacyPolicyUrl}
                      termsAndConditionsUrl={termsAndConditionsUrl}
                      height={600}
                    />
                  </Col>
                  <Col md={6} sm={12} className="mb-2">
                    <h6 style={BRANDING_FIELD_SUBTITLE_STYLE}>Login Preview</h6>
                    <LoginPreview
                      brandColor={brandColor}
                      buttonStyle={buttonStyle}
                      fontFamily={fontFamily}
                      logoUrl={committedLoginPreviewLogoUrl}
                      formAlignment={loginFormAlignment}
                      displayLogo={loginFormDisplayLogo}
                      signUpEnabled={tenant.self_signup}
                      googleOAuthEnabled={(slaLevel === "gold" && tenant.google_oauth) ? true : false}
                      height={600}
                    />
                  </Col>
                </Row>

                <hr style={BRANDING_SECTION_DIVIDER_STYLE} />

                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Semantic Colors</h4>
                <div ref={semanticColorsSectionRef} className="branding-colors-panel branding-semantic-colors-panel">
                  <Row className="branding-colors-row branding-paired-row">
                    <Col sm={12} md={6} lg={6} xl={6} className="branding-color-field-col">
                      {renderColorPickerField({
                        title: 'Info Color',
                        pickerKey: 'info',
                        color: infoColor,
                        setColor: setInfoColor,
                        fieldName: 'infoColor',
                        placeholder: infoColorDefault,
                        presetColors: semanticColorOptions.info,
                        wrapInCol: false,
                        helpText: COLOR_FIELD_HELP_TEXT.infoColor,
                      })}
                      <Alert color="info" className="branding-preview-alert branding-preview-alert-info">
                        <strong>Info.</strong> {SEMANTIC_ALERT_LOREM}
                      </Alert>
                    </Col>
                    <Col sm={12} md={6} lg={6} xl={6} className="branding-color-field-col">
                      {renderColorPickerField({
                        title: 'Success Color',
                        pickerKey: 'success',
                        color: successColor,
                        setColor: setSuccessColor,
                        fieldName: 'successColor',
                        placeholder: successColorDefault,
                        presetColors: semanticColorOptions.success,
                        wrapInCol: false,
                        helpText: COLOR_FIELD_HELP_TEXT.successColor,
                      })}
                      <Alert color="success" className="branding-preview-alert branding-preview-alert-success">
                        <strong>Success.</strong> {SEMANTIC_ALERT_LOREM}
                      </Alert>
                    </Col>
                  </Row>

                  <Row className="branding-colors-row branding-paired-row">
                    <Col sm={12} md={6} lg={6} xl={6} className="branding-color-field-col">
                      {renderColorPickerField({
                        title: 'Warning Color',
                        pickerKey: 'warning',
                        color: warningColor,
                        setColor: setWarningColor,
                        fieldName: 'warningColor',
                        placeholder: warningColorDefault,
                        presetColors: semanticColorOptions.warning,
                        wrapInCol: false,
                        helpText: COLOR_FIELD_HELP_TEXT.warningColor,
                      })}
                      <Alert color="warning" className="branding-preview-alert branding-preview-alert-warning">
                        <strong>Warning.</strong> {SEMANTIC_ALERT_LOREM}
                      </Alert>
                    </Col>
                    <Col sm={12} md={6} lg={6} xl={6} className="branding-color-field-col">
                      {renderColorPickerField({
                        title: 'Danger Color',
                        pickerKey: 'danger',
                        color: dangerColor,
                        setColor: setDangerColor,
                        fieldName: 'dangerColor',
                        placeholder: dangerColorDefault,
                        presetColors: semanticColorOptions.danger,
                        wrapInCol: false,
                        helpText: COLOR_FIELD_HELP_TEXT.dangerColor,
                      })}
                      <Alert color="danger" className="branding-preview-alert branding-preview-alert-danger">
                        <strong>Danger.</strong> {SEMANTIC_ALERT_LOREM}
                      </Alert>
                    </Col>
                  </Row>

                  <Row className="branding-colors-row branding-paired-row">
                    <Col sm={12} md={6} lg={6} xl={6} className="branding-color-field-col">
                      {renderColorPickerField({
                        title: 'Scooter Color',
                        pickerKey: 'scooter',
                        color: scooterColor,
                        setColor: setScooterColor,
                        fieldName: 'scooterColor',
                        placeholder: scooterColorDefault,
                        presetColors: semanticColorOptions.scooter,
                        wrapInCol: false,
                        helpText: COLOR_FIELD_HELP_TEXT.scooterColor,
                      })}
                      <Alert color="scooter" className="branding-preview-alert branding-preview-alert-scooter">
                        <strong>Scooter.</strong> {SEMANTIC_ALERT_LOREM}
                      </Alert>
                    </Col>
                  </Row>
                </div>

                <hr style={BRANDING_SECTION_DIVIDER_STYLE} />

                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Subscriptions</h4>
                <Row className="branding-paired-row">
                  <Col sm={12}>
                    <div
                      className={[
                        "branding-subscription-setting",
                        subscriptionsEnabled ? "is-enabled" : "",
                        !subscriptionsSlaEligible ? "is-locked" : "",
                      ].filter(Boolean).join(" ")}
                    >
                      <div className="branding-subscription-setting-main">
                        <div className="branding-subscription-setting-icon" aria-hidden="true">
                          <i className="ti-credit-card" />
                        </div>
                        <div className="branding-subscription-setting-copy">
                          <h6 className="branding-subscription-setting-title">
                            Enable subscriptions for users
                          </h6>
                          <p className="branding-subscription-setting-description">
                            Let users subscribe to your plans and receive the associated allowances and module permissions.
                          </p>
                          {!subscriptionsSlaEligible && (
                            <p className="branding-subscription-setting-note">
                              Available on <Link to="/sla">Business or Gold SLA</Link> only. <Link to="/sla">Upgrade your plan</Link> to use this feature.
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="branding-subscription-setting-radios" role="radiogroup" aria-label="Enable subscriptions for users">
                        <CustomInput
                          type="radio"
                          id="subscriptionsDisabled"
                          name="subscriptionsToggle"
                          label="Disable"
                          checked={!subscriptionsEnabled}
                          onChange={() => subscriptionsEnabled && handleSubscriptionsToggle(false)}
                          disabled={!subscriptionsSlaEligible || loading}
                        />
                        <CustomInput
                          type="radio"
                          id="subscriptionsEnabled"
                          name="subscriptionsToggle"
                          label="Enable"
                          checked={subscriptionsEnabled}
                          onChange={() => !subscriptionsEnabled && handleSubscriptionsToggle(true)}
                          disabled={!subscriptionsSlaEligible || loading}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <hr style={BRANDING_SECTION_DIVIDER_STYLE} />

                <h4 style={BRANDING_SECTION_TITLE_STYLE}>Company & Policies</h4>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <label htmlFor="companyName" style={BRANDING_POLICY_LABEL_STYLE}>Company Name</label>
                      <Input
                        type="text"
                        id="companyName"
                        name="companyName"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        placeholder="Your company name"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="companyWebsite" style={BRANDING_POLICY_LABEL_STYLE}>Website</label>
                      <Input
                        type="url"
                        id="companyWebsite"
                        name="companyWebsite"
                        value={companyWebsite}
                        onChange={(e) => setCompanyWebsite(e.target.value)}
                        placeholder="https://example.com"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="helpCenterUrl" style={BRANDING_POLICY_LABEL_STYLE}>Help Center URL</label>
                      <Input
                        type="url"
                        id="helpCenterUrl"
                        name="helpCenterUrl"
                        value={helpCenterUrl}
                        onChange={(e) => setHelpCenterUrl(e.target.value)}
                        placeholder="https://example.com/help-center"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="privacyPolicyUrl" style={BRANDING_POLICY_LABEL_STYLE}>Privacy Policy URL</label>
                      <Input
                        type="url"
                        id="privacyPolicyUrl"
                        name="privacyPolicyUrl"
                        value={privacyPolicyUrl}
                        onChange={(e) => setPrivacyPolicyUrl(e.target.value)}
                        placeholder="https://example.com/privacy-policy"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="cookiePolicyUrl" style={BRANDING_POLICY_LABEL_STYLE}>Cookie Policy URL</label>
                      <Input
                        type="url"
                        id="cookiePolicyUrl"
                        name="cookiePolicyUrl"
                        value={cookiePolicyUrl}
                        onChange={(e) => setCookiePolicyUrl(e.target.value)}
                        placeholder="https://example.com/cookie-policy"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="termsAndConditionsUrl" style={BRANDING_POLICY_LABEL_STYLE}>Terms and Conditions URL</label>
                      <Input
                        type="url"
                        id="termsAndConditionsUrl"
                        name="termsAndConditionsUrl"
                        value={termsAndConditionsUrl}
                        onChange={(e) => setTermsAndConditionsUrl(e.target.value)}
                        placeholder="https://example.com/terms-and-conditions"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {success && (
                  <Alert color="success">
                    Branding configuration updated successfully!
                    {!isDemoLocked() && (
                      <>
                        <br/>
                        <strong>Note: Please note that it may take up to 15 minutes for the changes to take effect.</strong>
                      </>
                    )}
                  </Alert>
                )}
                {error && (
                  <Alert color="danger">
                    Error saving branding configuration. Please try again.
                  </Alert>
                )}

                <Row>
                  <Col sm={12}>
                    <div className="float-right">
                      <Button
                        className="btn btn-success mr-2"
                        onClick={handleSave}
                        disabled={loading || !hasChanges || success || noDeploymentCredits || deploymentInProgress}
                      >
                        Save
                      </Button>
                      <Button
                        className="btn btn-info"
                        onClick={handleReset}
                        disabled={loading || success || noDeploymentCredits || deploymentInProgress}
                      >
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>

                {confirmModalOpen && (
                  <Modal isOpen={confirmModalOpen} centered={true}>
                    <ModalHeader>Are you sure that you want to update tenant configuration?</ModalHeader>
                    <ModalBody>
                      Please note that each update would result in deduction of <strong>1 Deployment Credit</strong>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn btn-secondary" onClick={() => setConfirmModalOpen(false)} disabled={loading}>
                        Cancel
                      </Button>
                      <Button className="btn btn-success" onClick={performSave} disabled={loading}>
                        Confirm
                      </Button>
                    </ModalFooter>
                  </Modal>
                )}

                <Modal
                  isOpen={enableSubscriptionsModalOpen}
                  centered={true}
                  toggle={() => setEnableSubscriptionsModalOpen(false)}
                >
                  <ModalHeader toggle={() => setEnableSubscriptionsModalOpen(false)}>
                    Enable subscriptions
                  </ModalHeader>
                  <ModalBody>
                    <p className="mb-4">
                      Select how your <strong>current users</strong> should transition before enabling subscriptions.
                    </p>

                    <div className="branding-subscription-options" role="radiogroup" aria-label="Sub-user transition options">
                      <button
                        type="button"
                        className={[
                          "branding-subscription-option",
                          existingUsersHandling === EXISTING_USERS_HANDLING.LEGACY ? "is-selected" : "",
                        ].join(" ")}
                        onClick={() => setExistingUsersHandling(EXISTING_USERS_HANDLING.LEGACY)}
                        role="radio"
                        aria-checked={existingUsersHandling === EXISTING_USERS_HANDLING.LEGACY}
                      >
                        <span className="branding-subscription-option-indicator" aria-hidden="true" />
                        <span className="branding-subscription-option-content">
                          <span className="branding-subscription-option-heading">
                            <span className="branding-subscription-option-label">Legacy Plan</span>
                            <span className="branding-subscription-option-badge">Recommended</span>
                          </span>
                          <span className="branding-subscription-option-text">
                            Preserve current allowances and permissions for existing users. Ideal for a smooth transition without disrupting active users.
                          </span>
                        </span>
                      </button>

                      <button
                        type="button"
                        className={[
                          "branding-subscription-option",
                          "branding-subscription-option-risk",
                          existingUsersHandling === EXISTING_USERS_HANDLING.SUBSCRIPTION ? "is-selected" : "",
                        ].join(" ")}
                        onClick={() => setExistingUsersHandling(EXISTING_USERS_HANDLING.SUBSCRIPTION)}
                        role="radio"
                        aria-checked={existingUsersHandling === EXISTING_USERS_HANDLING.SUBSCRIPTION}
                      >
                        <span className="branding-subscription-option-indicator" aria-hidden="true" />
                        <span className="branding-subscription-option-content">
                          <span className="branding-subscription-option-heading">
                            <span className="branding-subscription-option-label">Subscription Only</span>
                          </span>
                          <span className="branding-subscription-option-text">
                            Remove existing allowances and permissions. Users must subscribe to a plan to regain access to distribution, music links, landing pages, and other features.
                          </span>
                        </span>
                      </button>
                    </div>

                    {existingUsersHandling === EXISTING_USERS_HANDLING.SUBSCRIPTION && (
                      <Alert color="warning" className="mt-3 mb-0">
                        <strong>Please note:</strong> Existing users will have no allowances until they subscribe. This may immediately restrict uploads and paid features.
                      </Alert>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      className="btn btn-secondary"
                      onClick={() => setEnableSubscriptionsModalOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btn-success"
                      onClick={handleConfirmEnableSubscriptions}
                    >
                      Continue
                    </Button>
                  </ModalFooter>
                </Modal>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default BrandingConfig;
